import {
  Alert,
  Button,
  Flex,
  Loader,
  Modal,
  useComputedColorScheme,
} from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';
import { buttonTextColor } from 'utils/buttonUtils';

export interface ConfirmDialogProps {
  onConfirm: () => any;
  open: boolean;
  onClose: () => any;
  isLoading: boolean;
  title: string;
  body: string;
  confirmText?: string;
}

export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  onConfirm,
  open,
  onClose,
  isLoading,
  title,
  body,
  confirmText = 'Confirm',
}) => {
  const computedColorScheme = useComputedColorScheme('dark');
  return (
    <>
      <Modal
        opened={open}
        onClose={onClose}
        title={title}
        size="md"
        centered
        radius={'lg'}
        overlayProps={{ backgroundOpacity: 0.5, color: 'black' }}
      >
        {isLoading && (
          <Loader
            display={'flex'}
            w={'100%'}
            mb={'lg'}
            size="xl"
            style={{ margin: 'auto', justifyContent: 'center' }}
          />
        )}
        <Alert variant="light" color="red" icon={<IconAlertCircle />} mb={'lg'}>
          {body}
        </Alert>
        <Flex justify="center" gap="md">
          <Button
            onClick={onClose}
            justify="center"
            color="gray"
            c={buttonTextColor(computedColorScheme, false)}
          >
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            justify="center"
            color="green"
            c={buttonTextColor(computedColorScheme, isLoading)}
          >
            {confirmText}
          </Button>
        </Flex>
      </Modal>
    </>
  );
};
